import { useState } from 'react';
import './AboutUs.css';
let AboutUs=()=>{
    
    
    return(
        <div className='aboutuscont'>
            <h1 className='headingaboutus'>About Us</h1>
            <div>
                <p>
                    Comming Soon......!
                </p>
 

                 {/* <div>
                    <span className='rotatingdiv'>
                       <span className='subspan'></span> 
                    </span>
                </div> */}

                {/* <div className='rotatingcomp'>
                    <span className='one same'></span>    
                    <span className='two same'></span> 
                    <span className='three same'></span>   
                </div> */}
{/* <input className='fileupload' onChange={inputfilefun} type='file'/> */}
                {/* <div style={{border:"1px solid black", width:"500px", height:"400px"}}>
                    <img src={imgge}/>
                    <video controls src={imgge}/>
                </div>*/}
                
            </div> 
        </div> 
    );
}
export default AboutUs;